import { Response } from 'miragejs'

import { successResponseMockStructure } from './successResponseMockStructure'

import {
  OfferList,
  OfferItem,
  OfferUsedStatus,
  BuyStatus,
  HotDealStatus,
  OfferStatus,
  OfferType,
} from '~types/offer'
import { generateID } from '~utils'

// OFFERS
export const offers: OfferList = [
  {
    buyStatus: BuyStatus.REDEEMED,
    categories: { name: 'Apparels', id: 'db9cca24-ebd2-4e8c-8277-559dd002d728' },
    categoryId: 'db9cca24-ebd2-4e8c-8277-559dd002d728',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    discountCode: generateID(),
    discountUsed: OfferUsedStatus.USED,
    endDate: '2023-04-04T00:00:00.000Z',
    hotDeal: HotDealStatus.HOT_DEAL,
    id: 'e0a563e6-11ed-0fc1-3d84-bb94f94ec931',
    image: 'https://via.placeholder.com/300/09f/fff.png',
    locations: ['04750345-d7c3-4d77-ad0b-e7d3007ba5a4'],
    merchant: {
      name: 'Testing',
      email: 'testingm@yopmail.com',
      logo: 'https://rocketfuel-loyalty-data.s3.amazonaws.com/qa/shopLogo/Y2RlNjZmYmEtNWQ4MC0wYzAyLTc1YTEtYjY3N2MyZTVhZWZh_1666367412.png',
    },
    merchantId: 'cde66fba-5d80-0c02-75a1-b677c2e5aefa',
    merchantUrl: 'https://google.com',
    offerLeft: null,
    points: '100',
    shopLogo: 'test',
    shopName: 'test',
    startDate: '2022-04-04T00:00:00.000Z',
    status: OfferStatus.ACTIVE,
    title: '25% off on Online Purchase',
    totalCount: null,
    type: OfferType.PERCENTAGE,
    usedCount: null,
    value: '25',
  },
  {
    buyStatus: BuyStatus.NOT_REDEEMED,
    categories: {
      name: 'Apparels',
      id: 'db9cca24-ebd2-4e8c-8277-559dd002d728',
    },
    categoryId: 'db9cca24-ebd2-4e8c-8277-559dd002d728',
    description: '<p>A repellendus. Repud.</p>',
    discountCode: '',
    discountUsed: OfferUsedStatus.NOT_USED,
    endDate: '2022-10-27T00:00:00.000Z',
    hotDeal: HotDealStatus.NOT_HOT_DEAL,
    id: '21a34422-369e-4378-939f-6e25078b6429',
    image:
      'https://rocketfuel-loyalty-data.s3.amazonaws.com/offers/Y2RlNjZmYmEtNWQ4MC0wYzAyLTc1YTEtYjY3N2MyZTVhZWZh_1664436143.jpeg',
    locations: ['04750345-d7c3-4d77-ad0b-e7d3007ba5a4'],
    merchant: {
      name: 'Testing',
      email: 'testingm@yopmail.com',
      logo: 'https://rocketfuel-loyalty-data.s3.amazonaws.com/qa/shopLogo/Y2RlNjZmYmEtNWQ4MC0wYzAyLTc1YTEtYjY3N2MyZTVhZWZh_1666367412.png',
    },
    merchantId: 'cde66fba-5d80-0c02-75a1-b677c2e5aefa',
    merchantUrl: 'https://google.com',
    offerLeft: 41,
    points: '250',
    shopName: 'Non dolor et quod consectetur exercitationem',
    shopLogo:
      'https://rocketfuel-loyalty-data.s3.amazonaws.com/qa/shopLogo/Y2RlNjZmYmEtNWQ4MC0wYzAyLTc1YTEtYjY3N2MyZTVhZWZh_1668431952.jpeg',
    startDate: '2022-09-30T00:00:00.000Z',
    status: OfferStatus.INACTIVE,
    title: 'Ut qui qui earum sun',
    totalCount: 100,
    type: OfferType.FLAT,
    usedCount: 59,
    value: '60',
  },
  {
    buyStatus: BuyStatus.NOT_REDEEMED,
    categories: {
      name: 'Apparels',
      id: 'db9cca24-ebd2-4e8c-8277-559dd002d728',
    },
    categoryId: 'db9cca24-ebd2-4e8c-8277-559dd002d728',
    description: '<p>ggujj</p>',
    discountCode: '',
    discountUsed: OfferUsedStatus.NOT_USED,
    endDate: '2022-10-08T00:00:00.000Z',
    hotDeal: HotDealStatus.NOT_HOT_DEAL,
    id: '2cec1dd6-6cc4-483d-a744-4d966aff9189',
    image:
      'https://rocketfuel-loyalty-data.s3.amazonaws.com/offers/Y2RlNjZmYmEtNWQ4MC0wYzAyLTc1YTEtYjY3N2MyZTVhZWZh_1664534378.png',
    locations: ['04750345-d7c3-4d77-ad0b-e7d3007ba5a4'],
    merchant: {
      name: 'Testing',
      email: 'testingm@yopmail.com',
      logo: 'https://rocketfuel-loyalty-data.s3.amazonaws.com/qa/shopLogo/Y2RlNjZmYmEtNWQ4MC0wYzAyLTc1YTEtYjY3N2MyZTVhZWZh_1666367412.png',
    },
    merchantId: 'cde66fba-5d80-0c02-75a1-b677c2e5aefa',
    merchantUrl: 'https://google.com',
    offerLeft: 30,
    points: '50',
    shopName: 'Non dolor et quod consectetur exercitationem',
    shopLogo:
      'https://rocketfuel-loyalty-data.s3.amazonaws.com/qa/shopLogo/Y2RlNjZmYmEtNWQ4MC0wYzAyLTc1YTEtYjY3N2MyZTVhZWZh_1668431952.jpeg',
    startDate: '2022-10-01T00:00:00.000Z',
    status: OfferStatus.INACTIVE,
    title: 'jghgjgk',
    totalCount: 80,
    type: OfferType.FLAT,
    usedCount: 50,
    value: '11',
  },
  {
    buyStatus: BuyStatus.NOT_REDEEMED,
    categories: {
      name: 'Apparels',
      id: 'db9cca24-ebd2-4e8c-8277-559dd002d728',
    },
    categoryId: 'db9cca24-ebd2-4e8c-8277-559dd002d728',
    description: '<p>Discount on all the items up to 60 %</p>',
    discountCode: '',
    discountUsed: OfferUsedStatus.NOT_USED,
    endDate: '2022-10-31T00:00:00.000Z',
    hotDeal: HotDealStatus.NOT_HOT_DEAL,
    id: '07362df8-0ea3-4c14-b00e-87db2df04126',
    image:
      'https://rocketfuel-loyalty-data.s3.amazonaws.com/offers/Y2RlNjZmYmEtNWQ4MC0wYzAyLTc1YTEtYjY3N2MyZTVhZWZh_1664887638.png',
    locations: ['04750345-d7c3-4d77-ad0b-e7d3007ba5a4'],
    merchant: {
      name: 'Testing',
      email: 'testingm@yopmail.com',
      logo: 'https://rocketfuel-loyalty-data.s3.amazonaws.com/qa/shopLogo/Y2RlNjZmYmEtNWQ4MC0wYzAyLTc1YTEtYjY3N2MyZTVhZWZh_1666367412.png',
    },
    merchantId: 'cde66fba-5d80-0c02-75a1-b677c2e5aefa',
    merchantUrl: 'https://google.com',
    offerLeft: 11,
    points: '250',
    shopName: 'Non dolor et quod consectetur exercitationem',
    shopLogo:
      'https://rocketfuel-loyalty-data.s3.amazonaws.com/qa/shopLogo/Y2RlNjZmYmEtNWQ4MC0wYzAyLTc1YTEtYjY3N2MyZTVhZWZh_1668431952.jpeg',
    startDate: '2022-10-05T00:00:00.000Z',
    status: OfferStatus.ACTIVE,
    title: 'First Come First Get',
    totalCount: 70,
    type: OfferType.FLAT,
    usedCount: 59,
    value: '10',
  },
]

export const mockOffersResponse = successResponseMockStructure({ offers })

// SINGLE OFFER
export const mockSingleOfferResponse = (offerId: string) => {
  const offer = offers.find((offer) => offer.id === offerId)

  if (offer) {
    return successResponseMockStructure({ offer })
  }

  return new Response(
    500,
    {},
    {
      ok: false,
      statusCode: 404,
      data: {},
      message: 'ERROR.NOT.FOUND',
    }
  )
}

export const updateOffer = (offerId: string, fieldsToUpdate: Partial<OfferItem>) => {
  const newOfferIndex = offers.findIndex((offer) => offer.id === offerId)

  if (newOfferIndex === -1) {
    return new Response(
      500,
      {},
      {
        ok: false,
        statusCode: 500,
        data: {},
        message: 'OFFER_NOT_FOUND',
      }
    )
  }
}
